import { useState, useEffect, useCallback } from 'react';
import { authenticatedFetch } from '../../../../utils/api';

export const useTaggingData = (deviceInfo, preloadedData = null) => {
    const [taggingData, setTaggingData] = useState(preloadedData?.taggingData || []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [dataFetched, setDataFetched] = useState(
        preloadedData !== null && preloadedData.taggingData?.length > 0
    );

    const fetchTaggingData = useCallback(async () => {
        if (!deviceInfo) return;

        setLoading(true);
        setError(null);
        try {
            const res = await authenticatedFetch('/ManagerReport/GetTaggingData', {
                method: 'GET',
            });

            if (!res.ok) {
                throw new Error('Failed to fetch tagging data');
            }

            const response = await res.json();

            if (response.message != null) {
                console.log(response);
            } else {
                setTaggingData(response);
            }
        } catch (ex) {
            console.error('Error fetching tagging data:', ex);
            setError(ex.message);
        } finally {
            setLoading(false);
        }
    }, [deviceInfo]);

    useEffect(() => {
        if (dataFetched || !deviceInfo) return;
        fetchTaggingData().then(() => setDataFetched(true));
    }, [deviceInfo, dataFetched, fetchTaggingData]);

    return {
        taggingData,
        loading,
        error,
        dataFetched,
        refresh: fetchTaggingData,
    };
};
